import {Box, Typography} from '@mui/material';

import {EmptyStateIcon} from '@/app/icons/EmptyStateIcon/EmptyStateIcon';

interface EmptyStateProps {
  text: string;
}

export const GroupEmptyList = ({text}: EmptyStateProps) => {
  return (
    <Box className="groups-dashboard-empty-state">
      <EmptyStateIcon opacity={0.4} />
      <Typography className="groups-dashboard-empty-state-text">
        {text}
      </Typography>
    </Box>
  );
};
